// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"b169aad4","453":"6bdc07bd","563":"65067692","836":"d4fa0362"}[chunkId] + ".chunk.js";
};